export const categories = [
  {
    id: "children",
    name: "儿童牛奶片",
    description: "专为儿童研发的营养牛奶片，富含钙质与维生素，口感香甜，助力宝宝健康成长。",
    icon: "ri-bear-smile-line",
    slug: "children",
  },
  {
    id: "adult",
    name: "成人牛奶片",
    description: "满足成人日常营养需求的牛奶片，高钙低脂，适合办公室、运动后随时补充。",
    icon: "ri-user-heart-line",
    slug: "adult",
  },
  {
    id: "imported",
    name: "进口牛奶片",
    description: "精选澳洲、新西兰、欧洲等优质奶源产地进口牛奶片，品质有保障。",
    icon: "ri-global-line",
    slug: "imported",
  },
  {
    id: "high-calcium",
    name: "高钙牛奶片",
    description: "钙含量远超普通牛奶片，特别适合中老年人、孕妇及需要补钙的人群。",
    icon: "ri-heart-pulse-line",
    slug: "high-calcium",
  },
  {
    id: "sugar-free",
    name: "无糖牛奶片",
    description: "采用天然代糖，零蔗糖添加，适合控糖人群和注重健康饮食的消费者。",
    icon: "ri-leaf-line",
    slug: "sugar-free",
  },
  {
    id: "probiotic",
    name: "益生菌牛奶片",
    description: "添加活性益生菌，在补充钙质的同时调节肠道菌群，守护全家肠胃健康。",
    icon: "ri-shield-check-line",
    slug: "probiotic",
  },
];